import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default {
    namespaced: true,
    state() {
        return {
            fd: {},
            currentFD: null,
            fdError: null,
            liveFD: null,
            pastFDs: null,
            lastPastFDDoc: null,
            hasMorePastFDs: false,
        }
    },
    mutations,
    actions,
    getters
}